import { array, object, string } from "zod";

export const getProductQuestions = {
  input: object({ productId: string() }),
  output: object({ questions: array(string()) }),
};
